<template>
  <div class="tui-notice-board" bindtap="goWebview">
    <div class="tui-icon-bg">
      <img src="@/assets/icon/gonggao-2@2x.png" class="icon">
      <!-- <img src="." alt="">  -->
    </div>
    <div class="tui-scorll-div" bindtap="detail">
      <div class="tui-notice tui-animation">双11活动预告：全场5折，8折，9折起！</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["cmsData"],
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
.tui-notice-board {
  padding: 0 20px;
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  height: 45px;
}
.icon {
  width: 25px;
  height: 25px;
}

.tui-icon-bg {
  padding-right: 20px;
}

.tui-scorll-div {
  height: 100%;
  flex: 1;
  line-height: 45px;
  white-space: nowrap;
  overflow: hidden;
  color: #000;
  font-size: 28px;
}
.tui-notice {
  transform: translateX(100%);
  font-size: 24px;
  color: #666666;
}
.tui-animation {
  -webkit-animation: tui-rolling 12s linear infinite;
  animation: tui-rolling 12s linear infinite;
}

@-webkit-keyframes tui-rolling {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-170%);
  }
}

@keyframes tui-rolling {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-170%);
  }
}
</style>